import { render, staticRenderFns } from "./RecipeSelect.vue?vue&type=template&id=22f9dc02&scoped=true&"
import script from "./RecipeSelect.vue?vue&type=script&lang=js&"
export * from "./RecipeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f9dc02",
  null
  
)

export default component.exports